import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {put, takeEvery, all, fork} from "redux-saga/effects";
import ContentService from '../../services/content.service';
import TerritoryService from '../../services/territory.service';
import LabelService from "../../services/label.service";
//
// get territories list
function* getTerritoriesList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const search = action.payload?.search;
      let params = {page, pageSize, search,};

      const response = yield TerritoryService.list(params);
      // console.log({response})

      if (response?.data.statusCode === 200) {
        yield put(actions.getTerritoriesListSuccess(response?.data?.data));
      } else {
        yield put(actions.getTerritoriesListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getTerritoriesListFailure(error));
  }
}

function* getTerritoriesListSaga() {
  yield takeEvery(actionsTypes.GET_TERRITORIES_LIST_START, getTerritoriesList);
}

// get licensed territories list
function* getLicensedTerritoriesList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const label_service_id = action.payload?.label_service_id;
      let params = {page, pageSize, label_service_id,};

      const response = yield TerritoryService.licensedTerritoriesList(params);
      // console.log({response})

      if (response?.data.statusCode === 200) {
        yield put(actions.getLicensedTerritoriesListSuccess(response?.data?.data));
      } else {
        yield put(actions.getLicensedTerritoriesListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getLicensedTerritoriesListFailure(error));
  }
}

function* getLicensedTerritoriesListSaga() {
  yield takeEvery(actionsTypes.GET_LICENSED_TERRITORIES_LIST_START, getLicensedTerritoriesList);
}


function* addTerritory(action) {
  try {
    if (action.payload) {
      const response = yield TerritoryService.store(action.payload);

      if (response?.data.statusCode) {
        yield put(actions.addTerritorySuccess(response?.data));
      } else {
        yield put(actions.addTerritoryFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error) {
      error = "network error"
    }
    yield put(actions.addTerritoryFailure(error));
  }
}

function* addTerritorySaga() {
  yield takeEvery(actionsTypes.ADD_TERRITORY_START, addTerritory);
}
function* deleteTerritory(action) {
  try {
    if (action.payload) {
      const response = yield TerritoryService.deleteTerritory(action.payload);

      if (response?.data.statusCode) {
        yield put(actions.addTerritorySuccess(response?.data));
      } else {
        yield put(actions.addTerritoryFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error) {
      error = "network error"
    }
    yield put(actions.addTerritoryFailure(error));
  }
}

function* deleteTerritorySaga() {
  yield takeEvery(actionsTypes.DELETE_TERRITORY_START, deleteTerritory);
}
export function* territorySaga() {
  yield all([
    fork(getTerritoriesListSaga),
    fork(addTerritorySaga),
    fork(getLicensedTerritoriesListSaga),
    fork(deleteTerritorySaga),
  ]);
}
